import React from 'react'
import styled from 'styled-components'
import moneyWrap from '../assets/img/moneyWrap.png'
import { vw } from '../untils/styled'
import { T } from 'react-toast-mobile'

const SectionWrapper = styled.div`
    width: ${vw(535)};
    height: ${vw(185)};
    background: url(${moneyWrap}) no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    margin: 0 auto;
`

const InputWrapper = styled.div`
    font-family: DIGIFAW;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: ${vw(320)};
    height: ${vw(100)};
    position: relative;
    left: ${vw(40)};

    input {
        font-family: DIGIFAW;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        padding: 0;
        text-align: right;
        color: #fff;
        font-size: ${props => vw(props.fontSize + 20)};
        opacity: 0;
        z-index: 99;
    }
`

const Stage = styled.div`
    width: ${props => vw(props.width)};
    height: ${props => vw(props.width * 5 / 4)};
    overflow: hidden;
    perspective: 300px;
    position: relative;
`

const Wrapper = styled.div`
    position: absolute;
    left: ${vw(10)};
    transform-style: preserve-3d;
    backface-visibility: hidden;
    height: 100%;
    transform: ${props => `rotateX(${props.x}deg)`};
    transition: opacity 1s, transform 1s;
`

const NumberStyle = styled.div`
    position: absolute;
    display: flex;
    backface-visibility: hidden;
    text-align: center;
    color: #f8f8f8;
    font-size: ${props => vw(props.fontSize)};
    height: 100%;
    align-items: center;
    transform: ${props => `rotateX(${props.x}deg) translateZ(${vw(120)})`};
`

const NumberButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: ${vw(365)};
    margin-top: ${vw(30)};
    margin-left: ${vw(267)};

    > div {
        width: ${vw(154)};
        height: ${vw(68)};
        line-height: ${vw(68)};
        background-color: #8d919a;
        box-shadow: 0px 3px 10px 0px 
            rgba(42, 47, 61, 0.55), 
            inset 0px -4px 0px 0px 
            rgba(97, 99, 105, 0.69), 
            inset 0px 2px 1px 0px 
            rgba(214, 215, 217, 0.84);
        border-radius: ${vw(33)};
        text-align: center;
        color: rgba(255, 255, 255, 0.56);

        &:active {
            background-color: #333949;
            box-shadow: 0px 3px 10px 0px 
                rgba(80, 85, 101, 0.55), 
                inset 0px -4px 0px 0px 
                rgba(109, 114, 126, 0.69), 
                inset 0px 2px 1px 0px 
                rgba(31, 35, 45, 0.84);
            color: rgba(20, 21, 24, 0.4);
        }
    }
`

export default class MoneyConfig extends React.Component {
    constructor() {
        super()
        this.state = {
            totalValue: 100,
        }
        this.wrapperRotateFlag = []
        for (let i = 0; i < String(this.state.totalValue).length; i++) {
            this.wrapperRotateFlag.push({
                index: Number(String(this.state.totalValue)[i]),
                rotate: 0
            })
        }
    }
    rotateFlagUpdate = (item, index) => {
        let lastIndex = this.wrapperRotateFlag[index].index
        let lastRotate = this.wrapperRotateFlag[index].rotate
        let targeRotate;
        let abs
        let direct
        // 在一个循环中依据先后两数的大小，判断圆环旋转方向
        if (item >= lastIndex) {
            if (Math.abs(item - lastIndex) === Math.abs(lastIndex - item + 10)) {
                direct = true
                abs = Math.abs(item - lastIndex)
            } else if (Math.abs(item - lastIndex) < Math.abs(lastIndex - item + 10)) {
                direct = true
                abs = Math.abs(item - lastIndex)
            } else {
                direct = false
                abs = Math.abs(lastIndex - item + 10)
            }
        } else {
            if (Math.abs(item - lastIndex) === Math.abs(lastIndex - item + 10)) {
                direct = true
                abs = Math.abs(item - lastIndex)
            } else if (Math.abs(lastIndex - item) < Math.abs(item + 10 - lastIndex)) {
                direct = false
                abs = Math.abs(lastIndex - item)
            } else {
                direct = true
                abs = Math.abs(item + 10 - lastIndex)
            }
        }
        // let direct = item >=lastIndex 78901234567890123
        if (lastIndex === item) {
            if (lastRotate === 0) {
                targeRotate = item * (-36)
            } else {
                targeRotate = lastRotate
            }
        } else if (direct) {
            // 加
            targeRotate = lastRotate - abs * 36
        } else if (!direct) {
            // 减
            targeRotate = lastRotate + abs * 36
        }
        this.wrapperRotateFlag[index].index = item
        this.wrapperRotateFlag[index].rotate = targeRotate
        return targeRotate
    }
    addOne = () => {
        this.setState(preState => {
            if (preState.totalValue * 1 + 10 > 1000000) {
                T.notify('请输入小于等于1000000的值')
                return
            } 
            let newVal = preState.totalValue * 1 + 10;
            return {
                totalValue: newVal
            }
        });
    }
    minOne = () => {
        this.setState(preState => {
            if (preState.totalValue < 10) {
                T.notify('请输入大于0的值')
                return
            }
            let newVal = preState.totalValue * 1 - 10;
            return {
                totalValue: newVal
            }
        });
    }
    inputChange = (e) => {
        e.persist()
        let newVal = e.target.value.replace(/\D/g, '');
        if (newVal > 1000000) {
            T.notify('请输入小于等于1000000的值')
            return
        }
        this.setState(preState => ({
            totalValue: newVal * 1
        }));
    }
    render() {
        let numbersConfig = []
        String(this.state.totalValue).split('').forEach(item => {
            let itemConfig = (() => {
                let arr = []
                for (let i = 0; i < 10; i++) {
                    arr.push({
                        label: i,
                        rotateX: 360 / 10 * i
                    })
                }
                return arr
            })()
            numbersConfig.push(itemConfig)
        })

        // 增减位判断保护，需优化
        if (String(this.state.totalValue).length > this.wrapperRotateFlag.length) {
            for (let i = this.wrapperRotateFlag.length; i < String(this.state.totalValue).length; i++) {
                this.wrapperRotateFlag.push({
                    index: Number(String(this.state.totalValue)[i]),
                    rotate: 0
                })
            }
        }

        // 根据number length决定样式，平分320px宽，单个最大不超过80px, 字体大小取stage宽度
        let stageWidth = (() => {
            let length = String(this.state.totalValue).length;
            if (length > 4) {
                return 320 / length;
            } else {
                return 80;
            }
        })();

        this.props.valueSubmit(this.state.totalValue);

        return (
            <div>
                <SectionWrapper>
                    {/* <MoneyUnit>万元</MoneyUnit> */}
                    <InputWrapper fontSize={stageWidth}>
                        <input type="text" maxLength="7" pattern="[0-9]*" value={this.state.totalValue} onChange={this.inputChange} />
                        {
                            String(this.state.totalValue).split('').map((item, index) => (
                                <Stage width={stageWidth} key={index}>
                                    <Wrapper x={this.rotateFlagUpdate(Number(item), index)}>
                                        {
                                            numbersConfig[index].map((t, index) => (
                                                <NumberStyle
                                                    fontSize={stageWidth}
                                                    key={index}
                                                    x={t.rotateX}>{t.label}</NumberStyle>
                                            ))
                                        }
                                    </Wrapper>
                                </Stage>
                            ))
                        }
                    </InputWrapper>
                </SectionWrapper>
                <NumberButtonWrapper>
                    <div onClick={this.minOne}>-</div>
                    <div onClick={this.addOne}>+</div>
                </NumberButtonWrapper>
            </div>

        )
    }
}